namespace $.$$ {
	$mol_style_define( $shm_dashboard_admin_server, {
		Summary: {
			gap: $mol_gap.block,
			flex: { wrap: 'wrap' },
		},
		Storage_title: {
			padding: $mol_gap.block,
			font: { weight: 'bold' },
		},
		Details: {
			gap: $mol_gap.block,
			align: { items: 'flex-start' },
			flex: { wrap: 'wrap' },
		},
		Storage_panel: {
			flex: { direction: 'column', grow: 1, basis: '28rem' },
			minWidth: 0,
		},
		Storage_row: {
			padding: $mol_gap.block,
			border: { bottom: { width: '1px', style: 'solid', color: $mol_theme.line } },
			gap: $mol_gap.block,
		},
		Storage_name: { flex: { grow: 1 } },
		Storage_files: { color: $mol_theme.shade },
		Storage_size: { minWidth: '7rem', justify: { content: 'flex-end' } },
	} )

	$mol_style_define( $shm_dashboard_admin_server_charts, {
		Charts: {
			flex: { direction: 'column', grow: 1 },
			minWidth: '28rem',
			padding: $mol_gap.block,
			gap: $mol_gap.text,
		},
		Disk_chart_title: { font: { weight: 'bold' } },
		Pb_chart_title: { font: { weight: 'bold' } },
		Disk_chart: { height: '14rem', minHeight: '14rem' },
		Pb_chart: { height: '14rem', minHeight: '14rem' },
	} )
}
